<template>
  <div>
    <div
      class="confirmation-order"
      :style="
        postOrder.status === 'Em análise' ||
        orderData.orderStatus === 'W' ||
        (orderData && orderData.orderData && orderData.orderData.status === 'W')
          ? 'background-color: orange'
          : 'background-color: #14B86D'
      "
      v-if="!isSmAndDown"
    >
      <v-layout>
        <v-flex
          :class="postOrder.status === 'Em análise' ? 'xs12' : 'xs8'"
          class="pt-2"
        >
          <h2 class="checkout-h2 confirmation-order__title">
            <strong
              class="
              white--text
              "
              >{{ statusMessage }}</strong
            >
          </h2>
          <h4
            v-if="
              orderData.orderStatus === 'W' ||
                (orderData &&
                  orderData.orderData &&
                  orderData.orderData.status === 'W')
            "
            class="checkout-h4 confirmation-order__subtitle white--text conclusion-message"
            v-html="eventDetails.mensagem_aguardando_aprovacao_pedido"
          ></h4>
          <h4
            v-else-if="postOrder.status === 'Em análise'"
            class="checkout-h4 confirmation-order__subtitle white--text"
          >
            O seu pagamento está sendo análisado junto à operadora do cartão.
            Enviaremos uma confirmação via e-mail quando o status do seu
            pagamento mudar.
          </h4>
          <h4
            v-else
            class="checkout-h4 confirmation-order__subtitle white--text"
          >
            Os detalhes da sua compra foram enviados para
            <span class="white--text">{{ email }}</span>
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
          v-if="
            postOrder.status !== 'Em análise' &&
              orderData.orderStatus !== 'W' &&
              !(
                orderData &&
                orderData.orderData &&
                orderData.orderData.status === 'W'
              )
          "
          style="text-align: end !important"
        >
          <v-icon class="confirmation-order__icon" color="white">check</v-icon>
        </v-flex>
      </v-layout>
      <!-- <v-layout
        v-if="
          orderData &&
            orderData.status === 'paid' &&
            orderData.orderData &&
            orderData.orderData.hash_pedido
        "
      >
        <v-btn
          block
          round
          class="normal-text"
          color="white"
          dark
          depressed
          target="_blank"
          @click="handleOpenDialogConfirmationWhats"
          ><span style="color: #14B86D">Enviar pedido por WhatsApp</span>
        </v-btn>
      </v-layout> -->
    </div>
    <div
      class="confirmation-order_mobile"
      :style="
        postOrder.status === 'Em análise' || orderData.orderStatus === 'W'
          ? 'background-color: orange'
          : 'background-color: #14B86D'
      "
      v-else
    >
      <v-icon
        v-if="
          postOrder.status !== 'Em análise' && orderData.orderStatus !== 'W'
        "
        class="confirmation-order__icon_mobile text-xs-center"
        color="white"
        >check</v-icon
      >
      <h2 class="checkout-h2 confirmation-order__title text-xs-center">
        <strong class="white--text">{{ statusMessage }}</strong>
      </h2>
      <h4
        v-if="orderData.orderStatus === 'W'"
        class="checkout-h4 confirmation-order__subtitle white--text conclusion-message"
        v-html="eventDetails.mensagem_aguardando_aprovacao_pedido"
      ></h4>
      <h4
        v-else-if="postOrder.status === 'Em análise'"
        class="checkout-h4 confirmation-order__subtitle white--text text-xs-center"
      >
        O seu pagamento está sendo análisado junto à operadora do cartão.
        Enviaremos uma confirmação via e-mail quando o status do seu pagamento
        mudar.
      </h4>
      <h4
        v-else
        class="checkout-h4 confirmation-order__subtitle white--text text-xs-center"
      >
        Os detalhes da sua compra serão enviados para
        <span class="white--text">{{ email }}</span>
      </h4>
      <!-- <v-layout
        v-if="
          orderData &&
            orderData.status === 'paid' &&
            orderData.orderData &&
            orderData.orderData.hash_pedido
        "
      >
        <v-btn
          block
          round
          class="normal-text"
          color="white"
          dark
          depressed
          target="_blank"
          @click="handleOpenDialogConfirmationWhats"
          ><span style="color: #14B86D">Enviar pedido por WhatsApp</span>
        </v-btn>
      </v-layout> -->
    </div>
    <SendOrderByWhats
      :orderData="orderData ? orderData.orderData : {}"
      :dialogConfirmationWhats="dialogConfirmationWhats"
      @closeDialog="dialogConfirmationWhats = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SendOrderByWhats from './Delivery/SendOrderByWhats.vue';
import { incrementStringInSrc } from '../../utils/facebook-pixel';

export default {
  props: ['email'],
  data() {
    return {
      dialogConfirmationWhats: false,
    };
  },
  mounted() {
    console.log(this.postOrder, this.orderData);
    this.addFacebookPixel();
  },
  methods: {
    async addFacebookPixel() {
      let metaPixelStore =
        this.store && this.store.configs && this.store.configs.metaPixel
          ? this.store.configs.metaPixel
          : null;

      if (this.facebookPixel) {
        const facebookIntegrations = this.eventDetails.integracoes_publicas.filter(
          integration => integration.tipo === 'facebook_pixel'
        );

        facebookIntegrations.forEach(integration => {
          var mf = document.createElement('img');
          mf.src = `https://www.facebook.com/tr?id=${
            integration.credenciais.token
          }&ev=Purchase&eid=${this.body.codigo_evento}-${
            this.body.codigo_pedido
          }&currency=BRL&value=${
            this.totalWithoutTax
          }&cd[currency]=BRL&cd[value]=${
            this.totalWithoutTax
          }&cd[content_type]=product&cd[eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}`;

          mf.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

          mf.src = incrementStringInSrc(this.cartProducts, mf.src);

          mf.style = 'display:none;';
          mf.height = 1;
          mf.width = 1;
          document.getElementsByTagName('head')[0].appendChild(mf);
        });
      }

      if (metaPixelStore) {
        var img = document.createElement('img');
        img.src = `https://www.facebook.com/tr?id=${metaPixelStore}&ev=Purchase&eid=${this.body.codigo_evento}-${this.body.codigo_pedido}&currency=BRL&value=${this.totalWithoutTax}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

        img.src += `&cd[contents][0][id]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][eventId]=${`${this.body.codigo_evento}-${this.body.codigo_pedido}`}&cd[contents][0][quantity]=1`;

        img.src = await incrementStringInSrc(this.cartProducts, img.src);

        img.style = 'display:none;';
        img.height = 1;
        img.width = 1;
        document.getElementsByTagName('head')[0].appendChild(img);
      }
    },
    currency(value) {
      if (!value) return 0;
      return `${(value / 100).toFixed(2)}`;
    },
    handleOpenDialogConfirmationWhats() {
      this.dialogConfirmationWhats = true;
    },
  },
  computed: {
    ...mapGetters([
      'orderData',
      'store',
      'eventDetails',
      'body',
      'cartProducts',
    ]),
    totalAmount() {
      return this.$store.getters.totalAmount;
    },
    facebookPixel() {
      return this.$store.getters.facebookPixel;
    },
    postOrder() {
      return this.$store.getters.postOrder;
    },

    totalWithoutTax() {
      let total = 0;
      let somador = 0;

      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += v.valor * v.quantidade;
        });
      });
      total = somador;

      return total;
    },

    statusMessage() {
      if (
        (this.orderData && this.orderData.orderStatus === 'W') ||
        (this.orderData &&
          this.orderData.orderData &&
          this.orderData.orderData.status === 'W')
      ) {
        return 'Pedido aguardando aprovação';
      }

      if (this.postOrder && this.postOrder.status === 'Em análise') {
        return 'Pedido em Análise';
      }

      return 'Pedido efetuado!';
    },
  },
  components: { SendOrderByWhats },
};
</script>

<style lang="stylus">
@import '~@/assets/confirmation/confirmationOrder.styl';
</style>

<style>
.conclusion-message p,
.conclusion-message p strong {
  color: white !important;
  margin: 0px;
}
</style>
